<template>
    <nav>
        <router-link :to="getRouteFromID(link.link)" v-for="link in navigation.pages" :key="link.pageId" v-html="link.title" @click="navigationUsed"></router-link>
    </nav>
</template>
<script>
export default {
    name: "Navigation",
    data() {
        return {
            navigation: this.getNavigation()
        }
    },
    methods: {
        navigationUsed() {
            this.$emit('toggleNavigation')
        },
        getNavigation() {
            return app.manifest.data.custom.find(element => element.type === "customNavigation").data
        },
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/sass/_responsiveness.scss';
nav {
    position: fixed;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: var(--main-color);
    
    a {
        position: relative;
        font-size: 32px;
        font-weight: bold;
        color: #fff;
        margin-bottom: 65px;

        &:last-of-type {
            margin-bottom: 0;
        }

        @include mobile-only{
      font-size: 26px;
      margin-bottom: 45px;
    }
    }
}

@include tablet-down {
    nav {
        a {
            max-width: 90%;
        }
    }
}
</style>